.emptyState {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.content {
	display: flex;
	flex-direction: column;
	gap: 12px;
	text-align: center;
	align-items: center;
}

.wrapper {
	position: relative;
	margin-top: var(--header-height);
	background-color: var(--elevation-default);
	width: 100%;
	height: 100%;
}
